/* eslint-disable no-console */
/* global _HB_EVENTHUB_SAS */
/* global _HB_TIMEBLOCK_SEC */
/* global _HB_INTERVAL_SEC */

// import { EventHubProducerClient } from '@azure/event-hubs';
import { currentUserIdSelector } from '../../ReduxStorage/Auth/selectors';
import { currentCohortSelector } from '../../ReduxStorage/Cohorts/selectors';
import {
  currentCourseSelector,
  selectCurrentCoursePath,
  selectCurrentCourseSubscriptionId,
  selectCurrentCourseIsCollectingLearningTime,
} from '../../ReduxStorage/Courses/selectors';
import { selectCurrentInstitution } from '../../ReduxStorage/Institutions/selectors';
import { selectCurrentPagePath } from '../../ReduxStorage/Pages/selectors';
import { selectApplicationIpAddress } from '../../ReduxStorage/Application/selectors';

let pageActiveTime = 0;
let pulseIntervalActive = false;
let sendPulseInterval;
let newView = false;

const SEC_TO_MS = 1000;
const CHECKING_INTERVAL = _HB_INTERVAL_SEC * SEC_TO_MS;

let ehName = 'learningtime-dev';
if (_HB_EVENTHUB_SAS.includes('OLClientSenderLive')) {
  ehName = 'learningtime';
}
const ehEndpoint = `https://learningtime.servicebus.windows.net/${ehName}/messages`;

const sendHeartBeatData = () => async (dispatch, getState) => {
  const state = getState();

  const currentCohort = currentCohortSelector(state);
  // If we are in the context of a course and the linked institution is set to something
  // other than the institutionPrefix in the path then the current institution should be linked one.
  const currentInstitution = selectCurrentInstitution(state);

  const ipAddr = selectApplicationIpAddress(state);

  const heartBeatData = {
    timestamp: new Date().toISOString(),
    userId: currentUserIdSelector(state),
    pagePath: selectCurrentPagePath(state),
    cohortId: currentCohort ? currentCohort.get('id') : null,
    courseId: currentCourseSelector(state).get('id'),
    subscriptionId: selectCurrentCourseSubscriptionId(state),
    institutionId: currentInstitution ? currentInstitution.get('path') : null,
    ip: ipAddr,
    device: 'web',
    newView,
  };

  // send to Event Hub
  // Create a producer client to send messages to the event hub.
  // console.log('sendHeartBeatData', heartBeatData);
  fetch(ehEndpoint, {
    method: 'POST',
    headers: {
      Authorization: _HB_EVENTHUB_SAS,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(heartBeatData),
  })
    .then(() => {
      newView = false;
    })
    .catch((err) => {
      console.error(err);
    });
  // try {
  //   const producer = new EventHubProducerClient(_HB_EVENTHUB_CONN_STR);
  //   const batch = await producer.createBatch();
  //   batch.tryAdd({ body: heartBeatData });
  //   await producer.sendBatch(batch);
  //   await producer.close();
  // } catch (error) {
  //   // console.log(error);
  // }
};

const checkHalfTime = () => (dispatch) => {
  if (Math.round(pageActiveTime / _HB_TIMEBLOCK_SEC) > 0) {
    dispatch(sendHeartBeatData());
    pageActiveTime = 0;
  }
};

const sendPulse = () => (dispatch) => {
  pageActiveTime += _HB_INTERVAL_SEC;
  // console.log('sendPulse', pageActiveTime);

  if (pageActiveTime >= _HB_TIMEBLOCK_SEC) {
    dispatch(sendHeartBeatData());
    pageActiveTime = 0;
  }
};

const handlePausePulse = () => (dispatch) => {
  // console.log('handlePausePulse', pageActiveTime);
  dispatch(checkHalfTime());
  pulseIntervalActive = false;
  clearInterval(sendPulseInterval);
};

export const pausePulse = () => (dispatch) => {
  // console.log('pausePulse');
  if (pulseIntervalActive) {
    dispatch(handlePausePulse());
  }
};

const handleStartPulse = (trigger) => (dispatch) => {
  // console.log('handleStartPulse', trigger, pageActiveTime);
  newView = true;
  if (trigger && trigger === 'pageArrive') {
    // don't send initial heartbeat if the startPulse is trigger by visibility change
    dispatch(sendHeartBeatData());
    pageActiveTime = 0;
  }
  sendPulseInterval = setInterval(() => {
    dispatch(sendPulse());
  }, CHECKING_INTERVAL);
  pulseIntervalActive = true;
};

export const startPulse = (trigger) => (dispatch, getState) => {
  // console.log('startPulse', trigger);
  if (document.hidden || pulseIntervalActive) {
    // console.log('early return');
    return;
  }
  const state = getState();
  const coursePath = selectCurrentCoursePath(state);

  if (coursePath) {
    const isCollectingLearningTime = selectCurrentCourseIsCollectingLearningTime(
      state
    );
    if (isCollectingLearningTime) {
      // console.log('LearningTime enabled');
      dispatch(handleStartPulse(trigger));
    } else {
      // console.log('LearningTime not enabled');
    }
  } else {
    // console.log('no course path');
  }
};
